import { AlertModal, ConfirmationModal } from '@tassat/modal';
import { AlertTypes } from '@tassat/ui-definitions';
import * as React from 'react';

import ConfirmationWorkflowContext from './ConfirmationWorkflowContext';
import { SERVER_TIMEOUT, timeoutPromise } from '../helpers/helpers';

export default function ConfirmationWorkflowConsumer() {
    const context = React.useContext(ConfirmationWorkflowContext);
    if (!context) return null;

    const {
        confirmationWorkflowState,
        dispatchConfirmationWorkflowAction
    } = context;

    const {
        selectedItem,
        actionType,
        alertModalType,
        alertModalOpen,
        validationTitle,
        validationMessage,
        validated,
        actionInProgress,
        successTitle,
        successBody,
        failureTitle,
        failureBody,
        confirmModalOpen,
        confirmTitle,
        confirmBody,
        onConfirm,
        useTimeout
    } = confirmationWorkflowState;

    const closeAlertModal = () => {
        dispatchConfirmationWorkflowAction({ type: 'CLOSE_ALERT_MODAL' });
    };

    const closeConfirmationModal = () => {
        dispatchConfirmationWorkflowAction({ type: 'CLOSE_CONFIRM_MODAL' });
    };

    return (
        <>
            {confirmationWorkflowState && (
                <AlertModal
                    Body={validationMessage || successBody || failureBody!}
                    onClose={closeAlertModal}
                    open={alertModalOpen}
                    title={validationTitle || successTitle || failureTitle}
                    type={alertModalType as AlertTypes}
                />
            )}
            {confirmationWorkflowState && validated && (
                <ConfirmationModal
                    actionInProgress={actionInProgress}
                    body={confirmBody!}
                    onClose={closeConfirmationModal}
                    onConfirm={async () => {
                        try {
                            dispatchConfirmationWorkflowAction({ type: 'ACTION_CONFIRMED' });
                            if (useTimeout) {
                                await timeoutPromise(SERVER_TIMEOUT, onConfirm[actionType]?.(selectedItem) || undefined);
                            } else {
                                onConfirm[actionType]?.(selectedItem);
                            }
                        } catch (error: any) {
                            //TODO fix timeout error not actually being instanciated as an error
                            if (error?.name === 'TimeoutError') {
                                dispatchConfirmationWorkflowAction({
                                    type: 'SERVER_TIMEOUT',
                                    workflowConfiguration: {
                                        failureTitle: error.message,
                                        failureBody: 'Please refresh your screen and check if the action ' +
                                            'was successful or you can contact support for assistance.'
                                    }
                                });
                            } else {
                                // This condition should never be hit, adding as a precaution
                                dispatchConfirmationWorkflowAction({
                                    type: 'SERVER_ERROR',
                                    workflowConfiguration: {
                                        failureTitle: 'Something went wrong',
                                        failureBody: 'Something went wrong, please try again.'
                                    }
                                });
                            }
                        }
                    }}
                    open={confirmModalOpen}
                    title={confirmTitle}
                />
            )}
        </>
    );
}